/* eslint-disable react/no-unstable-nested-components */
import { InputLabel } from '@mui/material';
import MDEditor from '@uiw/react-md-editor';
import React from 'react';
import rehypeSanitize from 'rehype-sanitize';
import FormattedDescription from './FormattedDescription';

interface MarkdownEditorProps {
  name: string;
  id: string;
  value: string;
  handleChange: (value: string | undefined) => void;
}

const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  name,
  id,
  value,
  handleChange,
}) => {
  return (
    <>
      <InputLabel htmlFor={id}>{name}</InputLabel>
      <div data-color-mode="light">
        <MDEditor
          previewOptions={{ rehypePlugins: [[rehypeSanitize]] }}
          components={{
            preview: (source) => {
              return <FormattedDescription text={source} />;
            },
          }}
          height="100%"
          textareaProps={{
            placeholder: name,
            name,
            id,
          }}
          value={value}
          onChange={handleChange}
        />
      </div>
    </>
  );
};

export default MarkdownEditor;
